// @flow

export default {
	USER: 'user',
	ORGANIZATION: 'organization',
	LOCATION_GROUP: 'location-group',
	LOCATION: 'location',
}
